import Tagline from "./Tagline";

export default Tagline;
